<template>
  <section class="section feature-section">
    <div class="container">
      <div data-aos="fade-up">
        <span class="section-eyebrow">FEATURES</span>
        <h2 class="section-title">核心特性</h2>
        <p class="section-subtitle">{{ subtitle || '精心设计的功能模块，覆盖实际开发高频场景' }}</p>
      </div>
      <div class="feature-grid">
        <div
          v-for="(f, i) in features"
          :key="f.title"
          class="feature-card"
          data-aos="fade-up"
          :data-aos-delay="(i % 4) * 60"
        >
          <div class="feature-icon" :style="color ? { color, borderColor: color + '44', background: color + '14' } : {}">
            <i :class="f.icon"></i>
          </div>
          <h3 class="feature-title">{{ f.title }}</h3>
          <p class="feature-desc">{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  features: { type: Array, required: true },
  subtitle: { type: String, default: '' },
  color: { type: String, default: '' }
})
</script>

<style scoped>
.feature-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.feature-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius);
  padding: 28px 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.feature-card::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  background: var(--accent);
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.3s ease;
}
.feature-card:hover {
  border-color: var(--border);
  transform: translateY(-4px);
  background: var(--bg-elevated);
}
.feature-card:hover::before { transform: scaleY(1); }
.feature-icon {
  width: 48px; height: 48px;
  display: grid; place-items: center;
  border-radius: 12px;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 1.25rem;
  margin-bottom: 18px;
  border: 1px solid var(--border);
}
.feature-title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.15rem;
  margin-bottom: 8px;
}
.feature-desc {
  color: var(--text-muted);
  font-size: 0.92rem;
  line-height: 1.65;
}
@media (max-width: 1024px) {
  .feature-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .feature-grid { grid-template-columns: 1fr; }
}
</style>
